import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { CreateBusinessCategory } from '../../../../models/inModels/business-category';
import { BusinessService} from '../../../../services/business/business-category.service';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { SelectItem } from 'primeng/primeng';
import { AutoCompleteEvent } from '../../../../models/Utility/autoCompleteEvent';

@Component({
  selector: 'app-business-category-create',
  templateUrl: './business-category-create.component.html',
  styleUrls: ['./business-category-create.component.css']
})
export class BusinessCategoryCreateComponent {
  model: CreateBusinessCategory;
  loading: boolean = false;
  categories: SelectItem[];
  error: Message[];
  groups: string[];
  selectedGroup;
  uploading = false;
  constructor(private auth: AuthenticationService,
              private businessService: BusinessService,
              private router : Router,
              private confirmationService: ConfirmationService,
              ) { 
    this.model = new CreateBusinessCategory();
              }
    goBack(): void {
         this.router.navigate(['/business-category']);
              }
    save(): void {
                console.log(this.model);
                this.loading = true;
                this.businessService.create(this.model).then(
                  result => {
                    this.loading = false;
                    this.goBack();
                  },
                  error => {
                    this.loading = false;
                    this.error = [];
                    this.error.push({ severity: 'error', summary: 'Error', detail: error });
                  });
  }

  initGroupDropdown(event): void {
		this.businessService.getGroupsList(event).then(
			result => {
        
        this.groups = result;
        console.log(this.groups);
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
  
  setGroup(): void {
    this.model.GroupId = this.selectedGroup.value;
	}
  }



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/business-category-create/business-category-create.component.ts